import script from "./UdcTabbedSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UdcTabbedSelect.vue?vue&type=script&setup=true&lang=ts"

import "./UdcTabbedSelect.vue?vue&type=style&index=0&id=2c79bd42&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c79bd42"]])

export default __exports__